import { QueryStatus, skipToken } from "@reduxjs/toolkit/query";
import { useEffect, useState } from "react";
import { UnlinkedApplicationStatus } from "../../features/unlinked-application/unlinkedApplicationSlice";
import useAccountReferenceId from "./useAccountReferenceId";
import useAppSelector from "../../hooks/useAppSelector";
import { useEffectOnceWhen } from "rooks";
import { useGetSearchResultsQuery } from ".";
import useImpressionType from "./useImpressionType";
import useIsRemarketingSearch from "../../features/configuration/useIsRemarketingSearch";
import usePostUnlinkedAccount from "./usePostUnlinkedAccount";
export default function useSearchResults(options) {
    var _a = options || {}, impressionTypeOverride = _a.impressionTypeOverride, shouldPostUnlinkedAccount = _a.shouldPostUnlinkedAccount;
    var accountReferenceId = useAppSelector(function (state) { return state.applicant.accountReferenceId; });
    var didAbandonUnlinkedApplication = useAppSelector(function (state) {
        var unlinkedApplication = state.unlinkedApplication, applicant = state.applicant;
        var didLinkAccount = applicant.accountLinked.auto || applicant.accountLinked.home;
        var didAbandonUnlinkedApplication = [
            unlinkedApplication.status.auto,
            unlinkedApplication.status.home,
        ].includes(UnlinkedApplicationStatus.InProgress);
        return didAbandonUnlinkedApplication && !didLinkAccount;
    });
    var _b = useState(!didAbandonUnlinkedApplication), ready = _b[0], setReady = _b[1];
    var _c = usePostUnlinkedAccount(), postUnlinkedAccount = _c.postUnlinkedAccount, postUnlinkedAccountStatus = _c.status;
    var _d = useAccountReferenceId(), getAccountReferenceId = _d.getAccountReferenceId, status = _d.status;
    var isRemarketingSearch = useIsRemarketingSearch();
    var impressionType = useImpressionType();
    var searchQuery = useGetSearchResultsQuery(accountReferenceId && status !== QueryStatus.pending && ready
        ? {
            accountReferenceId: accountReferenceId,
            isRemarketingSearch: isRemarketingSearch,
            impressionType: impressionTypeOverride !== null && impressionTypeOverride !== void 0 ? impressionTypeOverride : impressionType,
        }
        : skipToken);
    useEffectOnceWhen(function () {
        postUnlinkedAccount().then(function () {
            setReady(true);
        });
    }, typeof accountReferenceId === "string" &&
        postUnlinkedAccountStatus.status === QueryStatus.uninitialized &&
        (didAbandonUnlinkedApplication || shouldPostUnlinkedAccount));
    useEffect(function () {
        if (!accountReferenceId && status !== QueryStatus.pending) {
            getAccountReferenceId();
        }
    }, [accountReferenceId, status, getAccountReferenceId]);
    return {
        searchQuery: searchQuery,
        postUnlinkedAccountStatus: postUnlinkedAccountStatus,
    };
}
